import { render, staticRenderFns } from "./IconJourney.vue?vue&type=template&id=67047bd2"
import script from "./IconJourney.vue?vue&type=script&lang=js"
export * from "./IconJourney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports